interface Metric {
  title: string;
  value: string | number;
  change: number | string;
  description: string;
  accentColor?: string;
  unit?: string;
  projectedChange?: number | string | null;
  projectedDescription?: string;
}

const ChangeBadge = ({ change }: { change: number | string }) => {
  const isPositive = Number(change) >= 0;

  return (
    <span
      className="flex align-items-center gap-1 border-round-3xl px-2 py-1 text-sm font-semibold"
      style={{
        background: isPositive ? "rgba(34, 197, 94, 0.1)" : "rgba(239, 68, 68, 0.1)",
        color: isPositive ? "#16a34a" : "#ef4444",
      }}
    >
      <i className={`pi ${isPositive ? "pi-arrow-up" : "pi-arrow-down"} text-xs`} />
      {Math.abs(Number(change))}%
    </span>
  );
};

const TotalsDisplayTile = ({
  title,
  change,
  value,
  description,
  accentColor,
  unit,
  projectedChange,
  projectedDescription,
}: Metric) => {
  return (
    <div className="flex flex-column gap-3 p-3">
      <div className="flex align-items-center gap-2">
        {accentColor && (
          <span
            style={{
              display: "inline-block",
              width: 10,
              height: 10,
              borderRadius: "50%",
              background: accentColor,
              flexShrink: 0,
            }}
          />
        )}
        <span className="text-700 font-semibold text-sm">
          {title}{unit ? <span className="text-color-secondary font-normal ml-1">({unit})</span> : null}
        </span>
      </div>

      <span className="font-bold text-900" style={{ fontSize: "2rem", lineHeight: 1 }}>
        {value}
      </span>

      <div className="flex flex-column gap-2">
        <div className="flex align-items-center gap-2">
          <ChangeBadge change={change} />
          <span className="text-color-secondary text-sm">{description}</span>
        </div>
        {projectedChange != null && (
          <div className="flex align-items-center gap-2">
            <ChangeBadge change={projectedChange} />
            <span className="text-color-secondary text-sm">{projectedDescription}</span>
          </div>
        )}
      </div>
    </div>
  );
};

export default TotalsDisplayTile;
